import React, { useState, useEffect, useRef } from "react";
import "./ArchivedUser.css";
import { Link } from "react-router-dom";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { MdOutlineYoutubeSearchedFor } from "react-icons/md";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { IoPrintOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import { IoMdArrowBack } from "react-icons/io";
import Snackbar from '@mui/material/Snackbar'; // Import Snackbar
import MuiAlert from '@mui/material/Alert';
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { TbRefresh } from "react-icons/tb";
import API_URL from "../../src/Config";

function ArchiveUser({ isSidebarExpanded }) {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isDeletePopup, setIsDeletePopup] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const [isSortPopup, setIsSortPopup] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [snackbarMessage, setSnackbarMessage] = useState(''); // New state for Snackbar
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [showActionHeader, setShowActionHeader] = useState(false);
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    const navigate = useNavigate();
    const [isAscending, setIsAscending] = useState(true);
    const canManageUsers = ["admin", "O & M Head", "IT"].includes(
        localStorage.getItem("user_role")
    );

    const [sortOrders, setSortOrders] = useState({
        Name: true,
        Designation: true,
        Department: true,
    });
    useEffect(() => {
        fetchData();
    }, []);

    const containerRef = useRef(null);

    useEffect(() => {
        fetchData();
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const showSnackbar = (message) => {
        setSnackbarMessage(message);
        setSnackbarOpen(true);
    };

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setIsDeletePopup(false);
            setIsDeletePopupOpen(false);
            setIsSortPopup(false);
            setSelectedRowIndex(null);
        }
    };

    const handleButtonClick = (index) => {
        setSelectedRowIndex(index === selectedRowIndex ? null : index);
    };



    const handleDeleteButtonClick = () => {
        setIsDeletePopupOpen(!isDeletePopupOpen);
    };

    const fetchData = async () => {
        try {
            const authKey = localStorage.getItem("authKey");

            const response = await axios.get(`${API_URL}/api/get_archived_users`, {
                headers: {
                    Authorization: authKey,
                },
            });

            setUsers(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching user data:", error.message);
            setLoading(false);
        }
    };

    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);
        setSelectedRows(newSelectAll ? users.map((user) => user.ID) : []);
        setChecked(newSelectAll);
    };

    const handleSelectRow = (userID) => {
        const updatedSelectedRows = selectedRows.includes(userID)
            ? selectedRows.filter((id) => id !== userID)
            : [...selectedRows, userID];

        setSelectedRows(updatedSelectedRows);
        setSelectAll(updatedSelectedRows.length === users.length);
        setChecked(updatedSelectedRows.length > 0);
    };

    const handleRestoreUser = async () => {
        try {
            const authKey = localStorage.getItem("authKey");
            const apiUrl = `${API_URL}/api/restore_archived_users`;

            const response = await fetch(apiUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authKey,
                },
                body: JSON.stringify({ ids: selectedRows }),
            });

            if (response.ok) {

                const updatedUsers = users.filter(
                    (user) => !selectedRows.includes(user.ID)
                );
                setUsers(updatedUsers);
                showSnackbar('Data restored successfully');
                setSelectedRows([]);
                setSelectAll(false);
                setChecked(false);
            } else {
                console.error("Failed to delete users");
            }
        } catch (error) {
            console.error("An error occurred while deleting users:", error);
        }
    };


    const handleCloseButtonClick = () => {
        setChecked(false);
        setSelectedRows([]);
        setShowActionHeader(false);
    };

    const handleSortpopup = () => {
        setIsSortPopup(!isSortPopup);
    };

    const handleSort = (column) => {
        setSortOrders(prevSortOrders => ({
            ...prevSortOrders,
            [column]: !prevSortOrders[column]
        }));
        setIsSortPopup(false);
        if (column === sortColumn) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortOrder("asc");
        }
    };

    const sortedUsers = () => {
        if (sortColumn) {
            return users.slice().sort((a, b) => {
                const first = a[sortColumn].toUpperCase();
                const second = b[sortColumn].toUpperCase();

                if (first < second) {
                    return sortOrder === "asc" ? -1 : 1;
                }
                if (first > second) {
                    return sortOrder === "asc" ? 1 : -1;
                }
                return 0;
            });
        }
        return users;
    };
    const handleBackCompany = () => {
        navigate('/user');

    };
    const handleSortOrderToggle = () => {
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    const handleRefresh = () => {
        fetchData();
    };
    return (
        <>
            <div
                className={`data-list-content-container page-content ${isSidebarExpanded ? "expanded" : "collapsed"
                    }`}
            >
                <div className="data-list-content" ref={containerRef}>
                    {isChecked ? (
                        <div className="action-header">
                            <div className="action-header-content">
                                <div className="action-header-content-leftside">
                                    <div className="action-button">
                                        <button className="print">
                                            <IoPrintOutline className="print-icon" />
                                        </button>
                                        <button className="bulk-update">Bulk Update</button>
                                        <button
                                            className="delete"
                                            onClick={handleDeleteButtonClick}
                                        >
                                            <HiOutlineDotsHorizontal className="delete-icon" />
                                        </button>
                                        {canManageUsers && isDeletePopupOpen && (
                                            <div className="delete-popup">
                                                <div className="delete-popup-content">
                                                    <button onClick={handleRestoreUser}>Unarchive</button>
                                                </div>
                                            </div>
                                        )}



                                    </div>
                                </div>
                                <div className="action-header-content-rightside">
                                    <button
                                        className="action-header-close-button"
                                        onClick={handleCloseButtonClick}
                                    >
                                        <IoCloseOutline className="action-header-close-icon" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="data-list-header">
                            <div className="data-list-header-content">
                                <div className="data-list-heading-content-left-side">
                                    <Tooltip title="Back" arrow>      <IoMdArrowBack className="back-company" onClick={handleBackCompany} /> </Tooltip>Archived Users
                                </div>
                                <div className="data-list-heading-content-right-side">
                                    <Tooltip title="Refresh List" arrow>
                                        <button className="refresh-button" onClick={handleRefresh}>
                                            <TbRefresh className="refresh-icon" />
                                        </button>
                                    </Tooltip>
                                    <button className="sort-button" onClick={handleSortpopup}>
                                        <PiDotsThreeOutlineVerticalFill className="sort-icon" />
                                    </button>
                                    {isSortPopup && (
                                        <div className="sort-popup-container">
                                            <div className="sort-popup-content">
                                                <div className="sort-by" onClick={handleSortOrderToggle}>SORT BY{isAscending ? '(Ascending)' : '(Descending)'}</div>
                                                <div className="sort-by-button">
                                                    <button onClick={() => handleSort("Name")}>Name {sortOrders.Name ? <MdExpandMore /> : <MdExpandLess />}</button>{" "}
                                                    <br />
                                                    <button onClick={() => handleSort("Designation")}>Designation {sortOrders.Designation ? <MdExpandMore /> : <MdExpandLess />}</button>{" "}
                                                    <br />
                                                    <button onClick={() => handleSort("Department")}>Department {sortOrders.Department ? <MdExpandMore /> : <MdExpandLess />}</button>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="data-list-body">
                        <div className="data-list-scroll-body">
                            <div className="data-list-table">
                                {loading ? (
                                    <div className="loader-container">
                                        <div className="loader"></div>
                                        <div>Loading...</div>
                                    </div>
                                ) : users.length > 0 ? (
                                    <table className="table multilevel-data">
                                        <thead>
                                            <tr>
                                                <th>
                                                    {canManageUsers && (
                                                        <input
                                                            type="checkbox"
                                                            checked={selectAll}
                                                            onChange={handleSelectAll}
                                                        />
                                                    )}
                                                </th>
                                                <th>SERIAL NO</th>
                                                <th>NAME</th>
                                                <th>DESIGNATION</th>
                                                <th>EMAIL</th>
                                                <th>CONTACT NO</th>
                                                <th>DEPARTMENT</th>

                                            </tr>
                                        </thead>
                                        <tbody className="data-list-scroll-bodys">
                                            {sortedUsers().map((user, index) => (
                                                <tr key={index} className="hoverable-row">
                                                    <td>
                                                        {canManageUsers && (
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedRows.includes(user.ID)}
                                                                onChange={() => handleSelectRow(user.ID)}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>{index + 1}</td>
                                                    <td>{user.Name}</td>
                                                    <td>{user.Designation}</td>
                                                    <td>{user.Email}</td>
                                                    <td>{user.ContactNo}</td>
                                                    <td>{user.Department}</td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="no-users-container">
                                        <div className="no-users-message">No archived users found</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                style={{ marginTop: '35px', marginLeft: '20px' }}
            >
                <MuiAlert onClose={handleSnackbarClose} severity="success">
                    {snackbarMessage}
                </MuiAlert>
            </Snackbar>
        </>
    );
}

export default ArchiveUser;
